const userSurveysReducer = (state = [], action) => {
    switch (action.type) {
      case "SET_USER_SURVEYS":
        return action.payload;
      default:
        return state;
    }
  }
  export default userSurveysReducer;